/** The git SHA baked into this browser bundle at build time. */
export const CLIENT_APP_VERSION = import.meta.env.VITE_APP_VERSION

/** Meta tag emitted into every production HTML document. */
export const APP_VERSION_META_NAME = 'planno-app-version'

/**
 * Read the version of the frontend that is being served right now.
 *
 * `/sign-in` is an app-shell route with a short edge-cache lifetime. Asking
 * for it with `no-store` avoids the browser cache; the edge may still be up
 * to a minute behind a deploy, which is why the caller keeps polling while
 * the backend says a rollout is in progress.
 */
export const fetchServedAppVersion = async (): Promise<string | null> => {
  if (typeof window === 'undefined') {
    return null
  }

  try {
    const response = await fetch('/sign-in?app-version-check=1', {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    })
    if (!response.ok) {
      return null
    }

    const document = new DOMParser().parseFromString(await response.text(), 'text/html')
    return (
      document
        .querySelector(`meta[name="${APP_VERSION_META_NAME}"]`)
        ?.getAttribute('content')
        ?.trim() || null
    )
  } catch {
    // A failed confirmation must never turn a suspected update into a toast.
    return null
  }
}
